import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { OMessageSitewide as OMessageSitewideComp } from '@marriott/mi-web-ui-kit';

export const OMessageSitewideConfig = {
  emptyLabel: 'OMessageSitewide',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-message-sitewide`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OMessageSitewide = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-message-sitewide-comp"
      data-component-name="o-message-sitewide"
      id={componentId}
      className={styleclass}
    >
      <EditableComponent config={OMessageSitewideConfig} {...props}>
        <OMessageSitewideComp {...props} />
      </EditableComponent>
    </div>
  );
};
